document.documentElement.classList.add('js');

(() => {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.getElementById('mobile-nav');
  if (!toggle || !nav) return;

  function setOpen(nextOpen) {
    toggle.setAttribute('aria-expanded', String(nextOpen));
    nav.hidden = !nextOpen;
    document.body.classList.toggle('mobile-nav-open', nextOpen);
  }

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    setOpen(!isOpen);
  });

  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setOpen(false));
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1219) {
      setOpen(false);
    }
  });
})();

// Product image slider
(() => {
  const slider = document.querySelector('[data-product-slider]');
  if (!slider) return;

  const track = slider.querySelector('[data-slider-track]');
  const slides = slider.querySelectorAll('[data-slide]');
  const dots = slider.querySelectorAll('[data-slider-dot]');
  if (!track || slides.length < 2) return;

  let current = 0;

  function goTo(index) {
    current = (index + slides.length) % slides.length;
    track.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => goTo(Number(dot.dataset.sliderDot)));
  });

  // Touch swipe
  let startX = 0;
  track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', (e) => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
  });
})();
